"use client"
import { motion } from "framer-motion"
import { Newspaper, ArrowUpRight } from "lucide-react"
import { Card } from "@/components/ui/card"

const pressItems = [
  {
    outlet: "DigiPen (Singapore)",
    title: "Sakthiish Vijayadass Develops Custom Business Solutions at Deloitte",
    date: "July 2025",
    link: "https://www.digipen.edu.sg/showcase/news/graduate-develops-custom-business-solutions-at-deloitte",
  },
]

export default function PressSection() {
  if (!pressItems || pressItems.length === 0) return null

  return (
    <section id="press" className="py-16 bg-secondary/30">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center text-sm font-semibold tracking-wide uppercase text-muted-foreground mb-6"
        >
          Featured In
        </motion.h2>

        <div className="max-w-2xl mx-auto space-y-4">
          {pressItems.map((item, index) => (
            <motion.a
              key={item.link}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="block group"
            >
              <Card className="flex items-center gap-4 p-4 sm:p-5 border-border/60 hover:border-primary/30 hover:shadow-md transition-all duration-300">
                <div className="p-2.5 rounded-lg bg-primary/10 text-primary shrink-0">
                  <Newspaper className="h-5 w-5" />
                </div>
                <div className="flex-grow min-w-0">
                  <p className="text-xs font-medium text-muted-foreground">
                    {item.outlet} &middot; {item.date}
                  </p>
                  {/* `truncate` cut this to "Sakthiish Vijayadass Develops Cus…"
                      on a phone. Two lines on mobile, one on wider screens. */}
                  <p className="font-semibold group-hover:text-primary transition-colors line-clamp-2 sm:truncate">
                    {item.title}
                  </p>
                </div>
                <ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0" />
              </Card>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  )
}
